module.exports = __webpack_public_path__ + "static/raon-376efbdecf1c0c3f8bd86ec46ab4d0db.png";